import { createContext } from 'react'

import type { NotificationItem } from '@/features/notifications/types'

export interface NotificationsContextValue {
  items: NotificationItem[]
  unreadCount: number
  isConnected: boolean
  markAllRead: () => void
}

export const NotificationsContext = createContext<NotificationsContextValue>({
  items: [],
  unreadCount: 0,
  isConnected: false,
  markAllRead: () => undefined,
})
